import { SubFeatureTogglingRecord } from './feature-toggling.type';
import { Feature } from './feature.enum';

export const featureToggling: SubFeatureTogglingRecord = {
  [Feature.COMMENT_DRAFT]: {
    prod: false,
  },
};
